export const STATUSES = ["all", "pending", "partial", "paid", "void"] as const;
export type Status = (typeof STATUSES)[number];
export const isStatus = (value: unknown): value is Status =>
  typeof value === "string" && (STATUSES as readonly string[]).includes(value);
